import {
  Component, OnInit, Input, ViewChild, ElementRef,
  forwardRef, AfterViewInit, Renderer2, HostListener,
  TemplateRef, ContentChild, Output, EventEmitter, HostBinding,
  SimpleChanges, OnChanges, ChangeDetectorRef, OnDestroy, Optional, Host, ChangeDetectionStrategy
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import {
  ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS,
  UntypedFormControl, FormGroupDirective, FormControlName, Validator
} from '@angular/forms';
import { AddMoreAutosuggestDirective } from '@otas/utils/directives/helper/add-more-autosuggest.directive';
import { FilterSearchPipe } from '@otas/utils/pipes/filter-search.pipe';
import * as _ from 'underscore';
import { AutoSuggestOption, AutoSuggestOptionGroup } from '@otas/utils/custom-components/auto-suggest/auto-suggest.component';


@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class MultiSelectComponent implements OnInit, Validator, OnChanges, OnDestroy, AfterViewInit, ControlValueAccessor {
  @Input() fullSelect: Boolean;
  mappedOptions: AutoSuggestOption[];
  @Input() options: AutoSuggestOption[] = [];
  @Input() optionsGroup: AutoSuggestOptionGroup[] = [];
  @Input() isGroup = false;
  @Input() type = 'text';
  @Input() placeholder: string;
  @Input() inputCssClass = 'form-control';
  @Output() selected: EventEmitter<AutoSuggestOption[]> = new EventEmitter<AutoSuggestOption[]>();
  @ViewChild('spanField', { static: true }) span: ElementRef;
  @ViewChild('inputField', { static: false }) input: ElementRef;
  @ViewChild('dropDownItem', { static: false }) ddItem: ElementRef;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() /* @HostBinding('class')*/ isDisable = false;
  @Input() selectedIds: number[] = [];
  public dropDown = false;
  selectedItem: AutoSuggestOption;
  selectedItems: AutoSuggestOption[] = [];
  inputValue: string;
  activeOption: AutoSuggestOption;
  activeOptions: AutoSuggestOption[] = [];
  documentClick: Subscription;
  @ContentChild(AddMoreAutosuggestDirective, { read: TemplateRef, static: false }) addMoreTemplate;

  onChange = (_f: any) => { };
  onTouched = () => { };
  constructor(public element: ElementRef,
    @Optional() @Host() private formGroupDirective: FormGroupDirective,
    private cd: ChangeDetectorRef) {
    this.closeDropDown = this.closeDropDown.bind(this);

  }
  selectAllForReports() {
    if (!!this.fullSelect) {
      this.options.forEach(element => {
        this.mappedOptions = this.options;
        this.itemSelected(element, true);
        this.closeDropDown();
      });
    }
  }
  onClickMultiple() {
    if (this.isChecked) {
      for (let index = 0; index < this.options.length; index++) {
        const e = this.options[index];
        e.checked = true;
        this.itemSelected(e, true);
        this.selectedItems = _.filter(this.mappedOptions, o => o.checked === true);
        this.selected.emit(this.selectedItems);
      }
    } else {
      for (let index = 0; index < this.options.length; index++) {
        const e = this.options[index];
        e.checked = false;
        this.itemSelected(e, true);
      }
    }


  }
  get isChecked() {
    return this.options.filter(e => e.checked)?.length === this.options?.length
  }

  isActive(o) {
    return !!this.activeOption ? this.activeOption.id === o.id : false;
  }
  ngOnChanges(changes: SimpleChanges) {
    this.selectAllForReports();
    if (this.optionsGroup && this.optionsGroup.length) {
      this.optionsGroup.forEach(a => {
        a.options.forEach(o => { o.checked = false; this.options.push(o); });
      });
    }
    this.mappedOptions = _.map(JSON.parse(JSON.stringify(this.options || [])));

    if (this.selectedIds && this.selectedIds.length) {
      this.selectedItems = [];
      // this.onChange(this.selectedItem.id);
      Array.from(this.selectedIds).forEach(element => {
        const sl = _.find(this.mappedOptions, e => e.id === element);
        if (!!sl) {
          sl.checked = true;
          this.selectedItems.push(sl);
        }
      });
    }

    this.cd.markForCheck();
  }
  ngOnInit() {


    const focusInput = fromEvent(this.span.nativeElement, 'click').subscribe((data: any) => {
      if (!this.isDisable && this.options && this.options.length) {
        this.dropDown = true;
        this.inputValue = '';
        setTimeout(() => {
          if (!!this.input) {
            this.input.nativeElement.focus();
          }
        }, 100);
      }
      this.cd.markForCheck();
    });
    fromEvent(this.span.nativeElement, 'focus').subscribe((data: any) => {
      if (!this.isDisable && this.options && this.options.length) {
        this.dropDown = true;
        this.inputValue = '';
        setTimeout(() => {
          if (!!this.input) {
            this.input.nativeElement.focus();

          }
        }, 100);
      }
      this.cd.markForCheck();
    });
    fromEvent(this.span.nativeElement, 'mousedown').subscribe((data: any) => {
      this.closeDropDown();
    });

  }
  inputChanges(value) {
    this.inputValue = value;
    this.activeOption = null;
    const filter = new FilterSearchPipe();
    this.options = [];
    const filteredOpts = filter.transform(_.map(this.mappedOptions), this.inputValue, 'name', 'startsWith');
    this.options = !!this.inputValue ?
      (filteredOpts && filteredOpts.length) ? filteredOpts : _.map(this.mappedOptions) : _.map(this.mappedOptions);
    this.cd.markForCheck();
  }
  @HostListener('keyup', ['$event'])
  keyUp(event: KeyboardEvent) {
    if (event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 38 ||
      event.keyCode === 40 || event.keyCode === 13) {
      event.preventDefault();
      return;
    }
  }
  @HostListener('focus')
  onFocus(event?: FocusEvent) {
    if (event && event.relatedTarget === null) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.isDisable) {
      this.span.nativeElement.focus();
    }
  }
  @HostListener('keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (!this.isDisable) {

      const activeIndex = this.options.indexOf(this.activeOption);
      // up
      if (event.keyCode === 38 && this.options.length) {

        const count: number = activeIndex < 0 ? this.options.length - 1 : activeIndex - 1;
        this.ensureHighlightVisible(count);
        event.preventDefault();
        return;
      }
      // down
      if (event.keyCode === 40 && this.options.length) {
        const count: number = activeIndex < 0 ? 0 : activeIndex + 1;
        this.ensureHighlightVisible(count);
        event.preventDefault();
        return;
      }
      // enter
      if (event.keyCode === 13) {
        event.preventDefault();
        if (!!this.inputValue && this.options.length && !this.activeOption) {

          this.activeOption = this.options[0];
        }
        this.itemSelected(this.activeOption, false);

        return;
      }
    }
    this.cd.markForCheck();
  }
  ngAfterViewInit() {
  }
  mouseOver(item: AutoSuggestOption) {
    this.activeOption = item;
  }
  mouseleave() {
    this.activeOption = null;
  }
  public validate(c: UntypedFormControl): any {
    const controlValue = c ? (c.value ? c.value.length : null) : null;
    const multiSelectDir: FormControlName =
      _.find(this.formGroupDirective.directives, (e: FormControlName) => e.valueAccessor instanceof MultiSelectComponent);
    if (multiSelectDir) {
      return multiSelectDir.errors && !controlValue ? multiSelectDir.errors : null;
    }
    return null;
  }
  public ensureHighlightVisible(active = 0): void {
    const container = this.element.nativeElement.querySelector('.dropdown-menu');
    this.itemSelected(this.options[active], true);

    if (!container) {
      return;
    }
    const choices = container.querySelectorAll('.drop-down-row');
    if (choices.length < 1) {
      return;
    }
    const activeIndex = active;
    if (activeIndex < 0) {
      return;
    }
    const highlighted: any = choices[activeIndex];
    if (!highlighted) {
      return;
    }
    container.scrollTop = activeIndex === 0 ? 0 : container.scrollTop;
    const posY: number = (highlighted.offsetTop + highlighted.clientHeight) - container.scrollTop;
    const height: number = container.offsetHeight;

    if (posY > height) {
      container.scrollTop += posY - height;
    } else if (posY < highlighted.clientHeight) {
      container.scrollTop -= highlighted.clientHeight - posY;
    }
  }
  itemSelected(item: AutoSuggestOption, dropDown = false) {
    this.dropDown = dropDown;
    this.selectedItem = item;
    this.activeOption = item;

    if (!!item) {
      item.checked = !item.checked;
      const chMOpt = _.find(this.mappedOptions, (i: AutoSuggestOption) => i.id === item.id);
      if (!!chMOpt) {
        chMOpt.checked = item.checked;
      }
      this.selectedItems = _.filter(this.mappedOptions, o => o.checked === true);
      this.selectedItem = item;
      this.activeOption = item;
      const selectedIds = this.selectedItems.map(i => i.id);
      this.onChange(selectedIds);
      this.selected.emit(this.selectedItems);
    }

    if (!this.dropDown) {
      this.closeDropDown();
    }

    this.cd.markForCheck();

  }
  closeDropDown() {

    // this.focusNext();
    this.selectedItems = _.filter(this.mappedOptions, o => o.checked === true);
    const selectdIds = !!this.selectedItems.length ? _.uniq(_.map(this.selectedItems, i => i.id)) : [];
    this.selectedItems = _.filter(this.mappedOptions, o => o.checked === true);
    if (this.dropDown) {
      this.onChange(selectdIds);
      this.selected.emit(selectdIds);
    }
    this.dropDown = false;
    this.inputValue = '';
    this.options = _.map(this.mappedOptions);
    this.cd.markForCheck();
  }


  writeValue(obj: any): void {
    console.log(obj, "value")
    if (!!this.selectedIds && this.selectedIds.length > 0) {
      this.selectedItems = [];
      // this.onChange(this.selectedItem.id);
      [...this.selectedIds].forEach(element => {
        const sl = _.find(JSON.parse(JSON.stringify(this.options || [])), e => e.id === element);
        if (!!sl) {
          sl.checked = true;
          this.selectedItems.push(sl);
        }
      });
    }
    else if (!!obj && obj !== 'null' && obj !== 'undefined') {
      this.selectedIds = obj;
      this.selectedItems = [];
      // this.onChange(this.selectedItem.id);
      [...obj].forEach(element => {
        const sl = _.find(JSON.parse(JSON.stringify(this.options || [])), e => e.id === element);
        if (!!sl) {
          sl.checked = true;
          this.selectedItems.push(sl);
        }
      });
    } else {
      this.selectedIds = [];
      this.selectedItems = [];
      this.mappedOptions.forEach((e) => {
        e.checked = false;
      });
    }
    this.cd.markForCheck();
  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisable = isDisabled;
  }
  ngOnDestroy(): void {
    if (this.documentClick) {
      this.documentClick.unsubscribe();
    }
  }


}
